<template>
  <div>
    <home-header></home-header>
    <div class="wrapper pt-3">
      <div class="row mb-3">
        <div class="col bg-white">
          <div class="p-3">
            <el-form ref="form" :model="form" class="search-form" label-width="80px">
              <el-form-item label="搜索条件">
                <el-input placeholder="请输入内容" v-model="form.query" class="input-with-select">
                  <el-select v-model="form.query_field" slot="prepend" placeholder="请选择" style="width: 103px;"
                             class="mobile-hidden">
                    <el-option label="公司名" value="companyName"></el-option>
                    <el-option label="ID" value="pid"></el-option>
                  </el-select>
                </el-input>
                <el-button type="primary" @click="btn_run_query"
                           class="ml-2">查看结果
                </el-button>
                <el-button class="mobile-hidden" @click="btn_cancel">重置选项</el-button>
              </el-form-item>
              <el-form-item class="mobile-hidden " label="出生日期">
                <el-date-picker v-model="form.date_range" type="monthrange" align="left" class="item_w"
                                unlink-panels range-separator="——" start-placeholder="开始" end-placeholder="结束"
                                :picker-options="birthOptions">
                </el-date-picker>
                <label class="item_label">地区</label>
                <el-select v-model="form.adProvs" placeholder="请选择省份" multiple class="item_w"
                           clearable v-on:change="getProv($event)">
                  <el-option v-for="item in provs" :key="item.value" :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
                <!--              <label class="item_label">城市</label>-->
                <!--              <el-select v-model="form.adCity" placeholder="请选择城市" class="item_w">-->
                <!--                <el-option v-for="item in citys" :key="item.value" :label="item.label"-->
                <!--                           :value="item.value">-->
                <!--                </el-option>-->
                <!--              </el-select>-->
                <label class="item_label">性别</label>
                <el-radio v-model="form.gender" label="male">男性</el-radio>
                <el-radio v-model="form.gender" label="female">女性</el-radio>
                <el-radio v-model="form.gender" label="">不限</el-radio>
              </el-form-item>
              <el-form-item class="mobile-hidden" label="企业规模">
                <el-select v-model="form.scaleList" clearable multiple placeholder="请选择" class="item_w">
                  <el-option v-for="item in scaleList" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
                <label class="item_label">行业</label>
                <el-cascader class="item_w"
                             v-model="form.indusList"
                             :options="indusList"
                             :show-all-levels="false"
                             :props="{ expandTrigger: 'hover',multiple: true, checkStrictly: true, value:'value',label:'label'}"
                             @change=""></el-cascader>
                <label class="item_label">职位</label>
                <el-select v-model="form.typeJoinList" clearable multiple placeholder="请选择" class="item_w_200">
                  <el-option v-for="item in occupList" :key="item.label" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
                <!--
                <label class="item_label">企业标签</label>
                <el-select v-model="form.portray" clearable placeholder="请选择" class="item">
                  <el-option v-for="item in portrayList" :key="item.label" :label="item.label"
                             :value="item.label"></el-option>
                </el-select>
                <label class="item_label">消费能力</label>
                <el-select v-model="form.companyList.income" clearable placeholder="请选择" class="item_w">
                  <el-option v-for="item in incomeList" :key="item.label" :label="item.label"
                             :value="item.label"></el-option>
                </el-select>
                -->

                <el-tag v-for="(tag,k) in form.typeJoinList" :key="tag" class="ml-2"
                        type="danger" closable @close="remove_tag(tag)">
                  {{ tag }}
                </el-tag>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <div class="bg-white p-3">
        <div class="pb-1" style="float:right">
          <el-button size="small" type="danger" @click="btn_export_data">导出数据
          </el-button>
        </div>
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                       :page-size="this.page.size" :total="this.page.total"
                       :current-page="this.page.index+1">
        </el-pagination>
        <el-table :data="dataList" stripe v-loading="listLoading" class="min-height">
          <el-table-column property="name" label="姓名" width="90"></el-table-column>
          <el-table-column property="gender" label="性别" width="80">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.gender=='male'">男</el-tag>
              <el-tag v-if="scope.row.gender=='female'" type="danger">女</el-tag>
            </template>
          </el-table-column>
          <el-table-column props="md5" label="OneID" width="150">
            <template slot-scope="scope">
              <label @click="getPhoneNumber(scope.row.id,scope.row.md5)">{{
                  scope.row.md5.length > 11 ? scope.row.md5.substring(0, 11) + '...' : scope.row.md5
                }}</label>
            </template>
          </el-table-column>
          <el-table-column property="companyName" label="公司名" width=""></el-table-column>
          <el-table-column property="adProv" label="省份" width="100"></el-table-column>
          <el-table-column prop="scale" label="公司规模" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.scale=='超大型'" type="danger" effect="dark" size="small">
                {{ scope.row.scale }}
              </el-tag>
              <el-tag v-if="scope.row.scale=='大型'" type="warning" effect="dark" size="small">
                {{ scope.row.scale }}
              </el-tag>
              <el-tag v-if="scope.row.scale=='中型'" type="primary" effect="dark" size="small">
                {{ scope.row.scale }}
              </el-tag>
              <el-tag v-if="scope.row.scale=='小型'" type="success" effect="dark" size="small">
                {{ scope.row.scale }}
              </el-tag>
              <el-tag v-if="scope.row.scale=='微型'" type="info" effect="dark" size="small">
                {{ scope.row.scale }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column property="typeJoin" label="职位" width="110"></el-table-column>
          <el-table-column property="share" label="股份" width="80"></el-table-column>
        </el-table>
      </div>
      <export-data :dlg_export_model="dlg_export_model" :form="form"
                   @exportClose="dlg_export_model=false"></export-data>
    </div>
    <home-footer></home-footer>
  </div>
</template>


<script>
import api from "../../api/rest";
import util from "../../api/util"
import { eventBus } from '../../api/event-bus.js';

import ExportData from "../../components/ExportData.vue";
import HomeHeader from "../../components/HomeHeader.vue";
import HomeFooter from "../../components/HomeFooter.vue";

export default {
  components: {HomeFooter, HomeHeader, ExportData},
  data() {
    return {
      dataType: "job",
      menuTitle: "职位列表",
      dataList: [],
      listLoading: false,
      hum_item: {},
      info: [],
      form: {
        query: "",
        adProv: "",
        adCity: "",
        date_range: [],
        typeJoinList: [],
        indusList: [],
        scaleList: [],
        adProvs: [],
        query_field: "companyName",
        order: "cnt_v",
        gender: "",
        idx: "staff",
      },
      folderList: [],
      page: {
        total: 0,
        index: 0,
        size: 20,
      },
      citys: [],
      dlg_detail: false,
      dlg_export_model: false,
      dlg_login_model: false,
      checkAll: false,
      isIndeterminate: true,
      birthOptions: util.setting.getPickeAgeOpt(),
      provs: util.setting.getProvs(),
      incomeList: util.setting.getIncomeList(),
      degreeList: util.setting.getDegree(),
      indusList: util.setting.getIndustry(),
      typeList: util.setting.getEntTypeList(),
      scaleList: util.setting.getEntScaleList(),
      occupList: util.setting.getOccupationList(),
      portrayList: util.setting.getPortrayList(),
      isActive: -1,
      collapse: api.storage.get('isCollapse'),
    };
  },
  methods: {
    shrinkMenu() {
      this.collapse = !this.collapse;
      api.storage.set('isCollapse', this.collapse);
    },
    btn_cancel(val) {
      this.form = {
        query: "",
        adProv: "",
        adCity: "",
        date_range: [],
        typeJoinList: [],
        indusList: [],
        scaleList: [],
        adProvs: [],
        query_field: "companyName",
        order: "cnt_v",
        gender: "",
        idx: "staff",
      }
    },
    getPhoneNumber(hum_id, md5) {
      if (api.storage.get('user') == null) {
        // 发送需要登录消息
        eventBus.$emit('event_loginRequire', 'true');
        return
      }
      let para = {
        "id": hum_id,
        "md5": md5
      }
      let api_url = "/search/humPhoneDec"
      api.remote.doPost(para, api_url).then((res) => {
        console.log(res)
        if (res.status == 'error') {
          this.$message({
            title: '',
            message: res.message,
            type: res.status
          })
        } else {
          this.$message({
            title: '',
            message: res,
            type: 'success'
          })
        }
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    menuClickHandler(item) {
      this.sltItem = item
      let tag = this.sltItem.value
      if (this.form.typeJoinList.indexOf(tag) == -1) {
        this.form.typeJoinList.push(tag)
        this.search_action()
      }
    },
    remove_tag(tag) {
      const idx = this.form.typeJoinList.indexOf(tag)
      if (idx > -1) {
        this.form.typeJoinList.splice(idx, 1)
      }
      this.search_action()
    },
    getInfoDetail(row) {
      console.log(row)
      let postData = {
        "_id": row.idMd5,
        "udb": true,
        index: 0,
        size: 10,
      }
      let api_url = '/search/empQuery'
      api.remote.doPost(postData, api_url).then((res) => {
        this.dlg_detail = true
        console.log(res)
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });

      let nodesData = {
        _id: row.pid,
        name: row.name,
      }
      let para = {
        ...nodesData,
        ...this.page
      }
      api_url = '/search/nodesQuery'
      api.remote.doPost(para, api_url).then((res) => {
        this.dlg_detail = true
        console.log(res)
        this.hum_item = res.content[0]
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    btn_export_data() {
      if (api.storage.get('user') == null) {
        // 发送需要登录消息
        eventBus.$emit('event_loginRequire', 'true');
      } else {
        this.form.total = this.page.total
        this.form.totalAmount = this.page.total / 100
        this.dlg_export_model = true;
      }
    },
    getHumDetail(row) {
      let postData = {
        "_id": row.idMd5,
        "udb": true,
        index: 0,
        size: 10,
      }
      let api_url = '/search/empQuery'
      this.loading_info = '加载中...'
      api.remote.doPost(postData, api_url).then((res) => {
        this.$message({
          message: res.content[0].mobile,
          type: "info",
        });
      }).catch((res) => {
        this.dlg_hum_detail = false
        api.handError.action(this, res);
      });
    },
    getProv: function (prov) {
      let tempCity = [];
      this.citys = [];
      this.form.birthCity = "";
      if (prov == '北京' || prov == '天津' || prov == '上海' || prov == '重庆') {
        return
      }
      let allCity = util.setting.getCity()
      for (var val of allCity) {
        if (prov === val.prov) {
          tempCity.push({
            label: val.label,
            value: val.label
          });
        }
      }
      this.citys = tempCity;
    },
    search_action() {
      this.listLoading = true;
      let para = {
        ...this.form,
        ...this.page
      }
      let api_url = '/slice/humQuery'
      api.remote.doPost(para, api_url).then((res) => {
        this.dataList = res.content;
        this.page.total = res.totalElements
        this.listLoading = false;
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    btn_run_query() {
      this.page.index = 0;
      this.search_action()
    },
    handleCurrentChange(val) {
      this.page.index = val - 1;
      this.search_action();
    },
    get_substr(val, maxLength) {
      if (val == null)
        return ""
      val = val.replace(";", "；")
      if (val.length < maxLength)
        return val

      var idx = val.length
      do {
        var a = val.lastIndexOf('；')
        var b = val.lastIndexOf('。')
        idx = a > b ? a : b
        if (idx > -1)
          val = val.substring(0, idx)
      } while (idx > maxLength)
      return val + "。"
    },
  },
  filters: {
    formatMoney(num) {
      num = num / 10000
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }) + "万";
    },
    formatDateTime(time) {
      var date = new Date(time)
      return date.format("yyyy-MM-dd")
    }
  },
  mounted() {
    if (this.$route.query.prov != null) {
      this.form.adProvs.push(decodeURI(this.$route.query.prov))
    }
    if (this.$route.query.city != null) {
      this.form.adCity = decodeURI(this.$route.query.city)
    }
    if (this.$route.query.indus != null) {
      this.form.indus = decodeURI(this.$route.query.indus)
      console.log(this.form.indus)
    }
    this.search_action()
  }
}
</script>



// WEBPACK FOOTER //
// Boss.vue?7c343786